export default __webpack_public_path__ + "static/media/baltimoreRavens@2x.dc1c323f.jpg";